export default __webpack_public_path__ + "crusher.png?1d02441ac7368b0ddc7898b42fd01623";